import gql from 'graphql-tag';

export const trackDocumentFieldClick = gql`
  mutation trackDocumentFieldClick($id: String!) {
    trackDocumentFieldClick(documentFieldId: $id)
  }
`;

export const trackVisitTime = gql`
  mutation trackVisitTime($pageNum: Float!, $pageTime: Float!, $pageId: String, $revision: Float) {
    trackVisitTime(
      payload: { pageNum: $pageNum, pageTime: $pageTime, pageId: $pageId, revision: $revision }
    )
  }
`;

export const trackVideo = gql`
  mutation trackVideo($videoId: String!, $viewDuration: Float!) {
    trackVideo(payload: { videoId: $videoId, viewDuration: $viewDuration })
  }
`;

export const trackContentLinkBlockClick = gql`
  mutation trackContentLinkBlockClick($id: String!) {
    trackContentLinkBlockClick(contentLinkBlockId: $id)
  }
`;

export const trackEditor = gql`
  mutation trackEditor($sections: [TrackEditorSectionArgs!], $nodes: [TrackEditorNodeArgs!]) {
    trackEditor(sections: $sections, nodes: $nodes)
  }
`;
